import { createApp } from 'vue';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import App from './App.vue';

import { createRouter, createWebHistory } from 'vue-router'; 
import HomeView from './views/HomeView.vue';
import BookingStatusView from './views/BookingStatusView.vue';
import BookingUnsubscribeView from './views/BookingUnsubscribeView.vue';    
import VacantRequestView from './views/VacantRequestView.vue';
import VacantRequestCommonClientView from './views/VacantRequestCommonClientView.vue';

const routes = [
    { path: '/', component: HomeView, meta: { title: 'New Booking' } },
    { path: '/b/:pathMatch(.*)*', component: BookingStatusView, meta: { title: 'Booking Status' } },
    { path: '/v/:pathMatch(.*)*', component: VacantRequestView, meta: { title: 'Appointment Interest' } },
    { path: '/w/:pathMatch(.*)*', component: VacantRequestCommonClientView, meta: { title: 'Appointment Interest' } },
    { path: '/unsubscribe/:pathMatch(.*)*', component: BookingUnsubscribeView, meta: { title: 'Unsubscribe' } }
];

const router = createRouter({
    history: createWebHistory(), 
    routes
});

router.beforeEach((to, from, next) => {
    let title = '';
    title = to.meta.title;
    title += ' - Health Casa';
    document.title = title;
    next();
});


// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

import * as Sentry from "@sentry/vue";

const vuetify = createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'mdi'
    }
})

const app = createApp(App);

Sentry.init({
    app,
    dsn: "https://115065c70c69e29ddd1cdabda502e5d4@o4508608303464448.ingest.de.sentry.io/4508608308641872",
    beforeSend(event) {
      if (window.location.hostname === "localhost") {
        return null;
      }
      return event;
    },
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });


app.use(vuetify).use(router).use(VCalendar, {}).mount('#app')


  
